import React, {useEffect, useState} from 'react';
import api from '../../../services/api';
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import BlockUi from 'react-block-ui';
import 'react-block-ui/style.css';

function ContractsForm(props){

  const [blocking, setBlocking] = useState(false);
  const [item, setItem] = useState({});

  const handleSubmit = (e) => {    

    setBlocking(true);   

    const {code} = e.target.elements;  
    
    let params = {
      code: code.value,
      location_id: props.location_id
    };

    let endpoint = '/contracts/create';
    if(item.id){
      params.id = item.id;
      endpoint = '/contracts/update';
    }    

    api.post(endpoint, params)
    .then(response => { 
        props.onHide(true);
        setBlocking(false);
    }).catch((error) => {
        setBlocking(false);
    });
    e.preventDefault();

};

  useEffect(() => {
    if(props.id !== null){
      setBlocking(true);
      api.get('/contracts/show/'+props.id, {
        params: {
          location_id: props.location_id
        }
      })
      .then(response => {     
          setBlocking(false); 
          setItem(response.data.data);               
      });   
    }else{
      setItem({});
    }
  },[props.id]);

  const onHide = () => {
    props.onHide();
  };

  return(
    
      <Modal
        {...props}
        size="lg"
        centered
        onHide={() => onHide()}
      >
        
        <BlockUi tag="div" blocking={blocking}>
          <Form onSubmit={handleSubmit}>
            <Modal.Header closeButton>
              <Modal.Title id="contained-modal-title-vcenter">
                {props.id ? 'Editar contrato' : 'Novo contrato'}
              </Modal.Title>
            </Modal.Header>            
            <Modal.Body>
              <Form.Group className="mb-3">
                <Form.Label>Identificador do contrato</Form.Label>
                <Form.Control name="code" type="text" placeholder="Digite aqui" defaultValue={item?.attributes?.code} />
              </Form.Group>                         
            </Modal.Body>          
            <Modal.Footer>
              <Button type="submit">Salvar</Button>
            </Modal.Footer>
          </Form>
        </BlockUi>
        
      </Modal>
    
  );
}

export default ContractsForm;